import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import * as XLSX from 'xlsx'

let ratio;
let utils = {

  aerialHeight: 20,
  unitDirection: {
    MAXDISTANCE: 500, // in meters
    MINDISTANCE: 10,
    MODDISTANCE: 50
  },
  checkImage: (url) => {
    let request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.send();
    request.onload = function () {
      if (request.status == 200) return true
      else return false

    }
  },
  validateNumber(value) {

    let regex = /^[0-9]*$/;
    return regex.test(value);

  },
  getDayByDurationAndStart(startDate, days = 0) {

    let date = new Date(startDate);
    return date.setDate(date.getDate() + days);

  },
  getCurrentDate(ms) {

    let today = String(new Date().toLocaleDateString('default')).split('/').map(d => d.length == 1 ? '0' + String(d) : d).join('-')
    return today
  },

  getFullTime(_date, time_str) {

    // convert this 05:01:19 PM time format to 24 hours format

    let time = time_str.split(' ')[0]
    let ampm = time_str.split(' ')[1]

    let hours = parseInt(time.split(':')[0])
    let minutes = parseInt(time.split(':')[1])
    let seconds = parseInt(time.split(':')[2])

    if (ampm == 'PM' && hours < 12) hours = hours + 12

    _date = _date || new Date().getTime()

    let date = new Date(_date)
    date.setHours(hours)
    date.setMinutes(minutes)
    date.setSeconds(seconds)

    console.log(date, 'date');

    return date.getTime()

  },

  getVehicleTypeStr(type) {

    let vehicleType = 'Default'

    if (type == '1') vehicleType = 'Auto'
    else if (type == '2') vehicleType = 'Hatchback'
    else if (type == '3') vehicleType = 'Hatchback'
    else if (type == '4') vehicleType = 'Sedan'
    else if (type == '5') vehicleType = 'SUV'
    else if (type == '6') vehicleType = 'Tempo Traveller'
    else if (type == '7') vehicleType = 'Bus'

    return vehicleType;

  },
  lerp: (x, y, a) => x * (1 - a) + y * a,
  // Slerp: (x, y, a) => (y * math.inv(x))**a * x,
  clamp: (a, min = 0, max = 1) => Math.min(max, Math.max(min, a)),
  invlerp: (x, y, a) => utils.clamp((a - x) / (y - x)),

  sleep: async function (time) {

    return new Promise(resolve => setTimeout(resolve, time))

  },
  formatNumber: (number, decimals = 2) => {

    let nums = String(number || 0).split('.')

    return parseInt(nums[1]) > 0 ? parseFloat(nums.join('.')).toFixed(decimals || 2) : nums[0]

  },
  getLocalFullDateLabel(ms, seperator = '/', has_time = true) {

    ms = ms || new Date().getTime()

    let data = new Date(ms)
    let yyyy = data.getFullYear();
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;


    let hours = data.getHours();
    let minutes = data.getMinutes();

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    let time = has_time ? `${hours}:${minutes}, ` : ''

    const D = time + [dd, mm, yyyy].join(seperator || '-')

    return D;
  },

  async getNEDirection({ start = undefined, end = undefined, waypoints = [], unit = 'kilometers', costing = 'taxi' }) {

    try {

      // let baseURL = "http://zeus.virtualmaze.in/india/route?data="
      let baseURL = "https://neapi.vmmaps.com/ne/api?op=optimized_route&data="

      if (!start && !end && !waypoints.length) return false

      let points = []

      if (start) points.push(start)
      if (waypoints.length) points.push(...waypoints)
      if (end) points.push(end)

      points = points.map(loc => { return { 'lat': loc['lat'], 'lon': loc['lon'] } })

      let payload = {
        "alternates": 2,
        "locations": points,
        "language": "en",
        "units": "kilometers",
        "costing": "auto",
        "costing_options": { "auto": { "use_highways": 1.0, "use_tolls": 0.5, "use_living_street": 0.2, "use_ferry": 0.5 } }
      }
      let url = baseURL + JSON.stringify(payload)

      console.log(url, 'url \n');

      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      response = await response.json()

      if (response && response.trip) return response.trip

      return false
    }
    catch (e) {
      console.log(e);
    }

  },
  exportTableToPDF(TableName, TableHeader, TableData, style) {
    console.log(TableHeader, TableData)

    // CREATE A WINDOW OBJECT.
    var win = window.open('', '', 'height=1000,width=1000');

    let content = `
            <html>
                <head>
                    <title>${TableName}</title>
                    ${style}
                </head>
                <body>
                    <table id='manage-officerides-tabel' class='manage-rides-tabel-container'>

                        <thead>
                        ${Object.keys(TableHeader[0]).map((head) => {
      console.log(Object.keys(TableHeader[0]))
      return `
                                <th>
                                    <td>${head.name}</td>
                                </th>
                            `

    })}
                            
                        </thead>

                        ${Object.keys(TableData).map((table) => {
      console.log(TableData)


      return `<tr>
                                ${Object.keys(TableHeader[0]).map((item) => {
        console.log(item.TableData)
        return `<tr>
                                    <td>${item.username}</td>
                                    


                                    <tr>`
      })}
                            </tr>`

    })}
                    </table>
                </body>
            </html>
        `
    console.log(TableHeader, TableData)
    win.document.write(TableHeader, TableData);
    // win.document.write('<html><head>');
    // win.document.write(`<title>${title}</title>`);   // <title> FOR PDF HEADER.
    // win.document.write(style);          // ADD STYLE INSIDE THE HEAD TAG.
    // win.document.write('</head>');
    // win.document.write('<body>');
    // win.document.write(`<table id='manage-officerides-tabel' class='manage-rides-tabel-container'>`);
    // win.document.write(tabel);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
    // win.document.write(`</table>`);
    // win.document.write('</body></html>');

    win.document.close();
    // win.print();
  },

  processData(TableHeader, Tabledata) {
    let dataStruct = {};
    const csvData = [];
    for (let i = 0; i < Tabledata.length; i += 1) {
      for (let j = 0; j < TableHeader.length; j += 1) {
        const { label, name } = TableHeader[j];
        if (label.toLowerCase() !== 'id') {

          if (Array.isArray(Tabledata[i][name])) {
            dataStruct[label] = Tabledata[i][name].join(',');
          } else {

            let _numbers = [
              'tolls', 'toll_cost', 'distance', 'diesels', 'diesel_cost',
              'fare', 'passenger_count', 'duetopay', 'amount_to_pay',
              'diesel_deduction', 'toll_amount', 'escort', 'escort_amount', 'distance'
            ]

            let getNumber = (value) => {

              if (_numbers.includes(name)) return isNaN(Number(Tabledata[i][name])) ? 0 : parseFloat(Number(Tabledata[i][name]).toFixed(2))
              else return String(value)
            }

            dataStruct[label] = getNumber(Tabledata[i][name])
          }
        }
      }
      csvData.push(dataStruct);
      dataStruct = {};
    }
    return csvData;
  },


  excelToJSON(file, callback) {

    let conver = (file) => {

      if (!file) return

      let fileReader = new FileReader();

      fileReader.onload = function (event) {

        let data = event.target.result;
        let workbook = XLSX.read(data, {
          type: "binary"
        });

        let xl_data = workbook.SheetNames.map(sheet => {
          return XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
        });

        if (xl_data) callback(xl_data)
      }

      fileReader.readAsBinaryString(file);

    }

    conver(file)

  },
  GMapsLatLngUrl(lat, lng) {
    const baseUrl = "https://www.google.com/maps/search/?api=1&query=";
    const locationString = `${lat},${lng}`;
    const encodedLocation = encodeURIComponent(locationString);
    return baseUrl + encodedLocation;
  },
  GMapsIframe(start, end, waypoints) {

    let base_url = "https://www.google.com/maps/dir/?api=1&origin="

    if (Array.isArray(start) && start.length) {

      base_url += `${start[0]},${start[1]}`
    }
    if (Array.isArray(end) && end.length) {

      base_url += `&destination=${end[0]},${end[1]}`
    }
    if (Array.isArray(waypoints) && waypoints.length) {

      base_url += `&waypoints=`


      let _waypt = waypoints.map((wpt, i) => {
        return [wpt.lat, wpt.lon].join(',')
      })

      base_url += _waypt.join('|')
    }

    base_url += "&travelmode=driving"

    return base_url;

  },
  getCSVData(data) {

    let result = []

    var rows = data.split("\n");

    for (var i = 0; i < rows.length; i++) {

      let row = []

      var cells = rows[i].split(",");

      if (cells.length > 1) {

        for (var j = 0; j < cells.length; j++) {

          row.push(cells[j])

        }
      }

      result.push(row)
    }

    return result
  },
  validatePaymentCSV(data) {

    let isValid = true
    let length = 17

    data.forEach((d, i) => {

      if (d.length != length) isValid = false

      // if(isValid && d.length > 10 && d[10][0] != 'N') isValid = false

      if (isValid && d.length > 11 && !['E', 'R'].includes(d[11])) isValid = false
    })



    return isValid
  },

  exportTableToExcel(TableHeader, Tabledata, file_name) {

    const csvData = this.processData(TableHeader, Tabledata);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    const reader = new FileReader();
    reader.onload = (e) => {
      const link = document.createElement('a');
      link.download = file_name || 'document';
      link.href = e.target.result;
      link.click();
    };
    reader.readAsDataURL(data);
  },
  _exportTableToExcel(sheets, file_name) {
    if (!Array.isArray(sheets)) return false;

    let Sheets = {};
    let SheetNames = [];

    sheets.forEach((sht, i) => {
      let { tableHeader, tabledata, sheet_name } = sht;
      const csvData = this.processData(tableHeader, tabledata);
      const ws = XLSX.utils.json_to_sheet(csvData);

      const colTextFormat = { t: 's', z: '@' };
      ws['J'] = { ...ws['J'], ...colTextFormat }; // Format column J to text
      ws['K'] = { ...ws['K'], ...colTextFormat }; // Format column K to text

      Sheets[sheet_name] = ws;
      SheetNames.push(sheet_name);
    });

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const wb = { Sheets, SheetNames };

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    const data = new Blob([excelBuffer], { type: fileType });
    const reader = new FileReader();
    reader.onload = (e) => {
      const link = document.createElement('a');
      link.download = file_name || 'document';
      link.href = e.target.result;
      link.click();
    };
    reader.readAsDataURL(data);
  },
  Slerp: function ({ time, location, movement, }) {

    const TRACK = movement.track;

    if (time) {

      let { startTime, endTime, hoverTime } = time;
      let duration = endTime - startTime;
      let cursorTime = hoverTime - startTime;

      let interol = cursorTime / duration * 100;
      let _totalDistance = 0

      TRACK.forEach((ar, i) => {
        if (i != TRACK.length - 1)
          _totalDistance += this.calculateDistanceBetwwenPoints(TRACK[i][0], TRACK[i][1], TRACK[i + 1][0], TRACK[i + 1][1])
      })

      let distance = interol * _totalDistance / 100
      let _per_d = 0;
      let latlng = []

      for (let _i = 0; _i < TRACK.length; _i++) {

        if (_i == TRACK.length - 1) return
        _per_d += this.calculateDistanceBetwwenPoints(TRACK[_i][0], TRACK[_i][1], TRACK[_i + 1][0], TRACK[_i + 1][1])
        if (_per_d > distance) {
          let interpolationValue = (_per_d - distance) / _totalDistance;
          interpolationValue = interpolationValue > 1 ? 1 : interpolationValue
          interpolationValue = interpolationValue < 0 ? 0 : interpolationValue
          let lat = this.lerp(TRACK[_i][0], TRACK[_i + 1][0], interpolationValue)
          let lng = this.lerp(TRACK[_i][1], TRACK[_i + 1][1], interpolationValue)
          latlng = [lat, lng];
          break;
        }
      }

      return latlng;

    }
    else if (location) {

      let _totalDistance = 0
      let _per_d = []
      let __per_d = 0
      const _lDis = []

      TRACK.forEach((ar, i) => {
        if (i == TRACK.length - 1) return;

        let mlatlng = [(TRACK[i][0] + TRACK[i + 1][0]) / 2, (TRACK[i][1] + TRACK[i + 1][1]) / 2]

        _totalDistance += this.calculateDistanceBetwwenPoints(TRACK[i][0], TRACK[i][1], TRACK[i + 1][0], TRACK[i + 1][1]);
        _lDis.push(this.calculateDistanceBetwwenPoints(mlatlng[0], mlatlng[1], location[0], location[1]))
        __per_d += this.calculateDistanceBetwwenPoints(TRACK[i][0], TRACK[i][1], TRACK[i + 1][0], TRACK[i + 1][1])
        _per_d.push(__per_d)
      })

      let li = _lDis.indexOf(Math.min(..._lDis))
      let dPer = ((_per_d[li == 0 ? li : li - 1] + Math.min(..._lDis)) / _totalDistance) * 100
      let time = movement.startTime + ((dPer * (movement.endTime - movement.startTime)) / 100)

      return time;
    }

  },
  getCirclePoints: function (centre, rad, angle) {
    // Formula for calculate points => Math.cos and sin functions take radians..so, convert angle
    // into radians and apply it

    let point_x = centre[0] + rad * window.Math.cos(angle * (window.Math.PI / 180))
    let point_y = centre[1] + rad * window.Math.sin(angle * (window.Math.PI / 180))

    return [point_x, point_y];
  }
  ,

  rotatePoint: function (origin, coord, angle) {

    let [cx, cy] = origin
    let [x, y] = coord

    let radians = (Math.PI / 180) * angle

    let cos = Math.cos(radians)
    let sin = Math.sin(radians)

    let nx = (cos * (x - cx)) + (sin * (y - cy)) + cx
    let ny = (cos * (y - cy)) - (sin * (x - cx)) + cy

    return [nx, ny];
  },

  rotatePointArray: function (origin, coords, angle) {
    let points = []
    coords.forEach(coord => {

      let point = utils.rotatePoint(origin, coord, angle)
      points.push(point)

    })

    return points
  },

  rotatePositionArray: function (origin, coords, angle) {

    let points = []

    for (let i = 0; i < coords.length; i += 2) {

      let lon = coords[i]
      let lat = coords[i + 1]

      let point = utils.rotatePoint(origin, [lon, lat], angle)
      points.push(...point)

    }

    return points
  },

  calculateSlope: function (p1, p2) {

    let yDiff = p2[1] - p1[1]
    let xDiff = p2[0] - p1[0]


    return yDiff / xDiff

  },

  calculatePointBetwwenTwoPointsAtaDistance: function (lon1, lat1, lon2, lat2, distance) {

    let totalDistance = this.calculateDistanceBetwwenPoints(lon1, lat1, lon2, lat2)
    let distanceRatio = distance / totalDistance
    let point = [(1 - distanceRatio) * lon1 + distanceRatio * lon2, (1 - distanceRatio) * lat1 + distanceRatio * lat2]
    return point
  },

  calculateDistanceBetwwenPoints: function (lon1, lat1, lon2, lat2) {

    function toRad(Value) {
      return Value * Math.PI / 180;
    }

    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d * 1000;
  },

  hexToRgb: function (hex) {

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  randomId: function () {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },

  componentToHex: function (c) {

    let hex = c.toString(16);

    return hex.length == 1 ? "0" + hex : hex;
  },

  rgbToHex: function (r, g, b) {

    return "#" + utils.componentToHex(r) + utils.componentToHex(g) + utils.componentToHex(b);
  },

  getMidpoint: function (p1, p2) {

    return [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2]

  },

  getMidPointWithHeight: function (p1, p2, p1Height, p2Height) {

    return [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2, (p1Height + p2Height) / 2]
  },

  multiplyMatrix: function (m1, m2) {
    let result = [];

    for (let i = 0; i < m1.length; i++) {

      result[i] = [];

      for (let j = 0; j < m2[0].length; j++) {
        let sum = 0;

        for (let k = 0; k < m1[0].length; k++) {
          sum += m1[i][k] * m2[k][j];
        }

        result[i][j] = sum;

      }
    }

    return result;
  },

  getUniqueId: function () {

    return String(uuidv4())
  },

  removeContainer: (params = []) => {

    params.forEach((param) => {

      let items = param.parent.querySelectorAll(param.key)

      for (const itm of items) {
        if (param.parent && param.parent.contains(itm)) param.parent.removeChild(itm)
      }
    })
  },
  getTextImg: function (text, fontSize, cheight, cwidth, bgColor, textColor, x, y) {
    let img = document.createElement("img");
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext('2d');
    canvas.width = cwidth;
    canvas.height = cheight;
    /// lets save current state as we make a lot of changes        
    ctx.save();

    /// set font
    ctx.font = fontSize;

    /// draw text from top - makes life easier at the moment
    ctx.textBaseline = 'top';

    /// color for background
    ctx.fillStyle = bgColor;

    /// get width of text
    let width = ctx.measureText(text).width;
    //let height = ctx.measureText(text).height;

    /// draw background rect assuming height of fontSize
    ctx.fillRect(x, y, width, parseInt(fontSize, 10));

    /// text color
    ctx.fillStyle = textColor;

    /// draw text on top
    ctx.fillText(text, x, y);

    /// restore original state
    ctx.restore();
    img.src = canvas.toDataURL();
    return img
  },

  getRatioBetweenNumbers(num_1, num_2) {
    for (let num = num_2; num > 1; num--) {
      if ((num_1 % num) == 0 && (num_2 % num) == 0) {
        num_1 = num_1 / num;
        num_2 = num_2 / num;
      }
    }
    ratio = [num_1, num_2];
    //ratio = num_1+":"+num_2;

    return ratio;
  },


  findAngleBetweenThreePoints(A, B, C) {
    let AB = Math.sqrt(Math.pow(B[0] - A[0], 2) + Math.pow(B[1] - A[1], 2));
    let BC = Math.sqrt(Math.pow(B[0] - C[0], 2) + Math.pow(B[1] - C[1], 2));
    let AC = Math.sqrt(Math.pow(C[0] - A[0], 2) + Math.pow(C[1] - A[1], 2));
    return Math.acos((BC * BC + AB * AB - AC * AC) / (2 * BC * AB)) * 57.2958;
  },

  radiansToDegrees(radians) {
    var pi = window.Math.PI;
    return radians * (180 / pi);
  },

  findPointSide(linePA, linePB, point) {

    return ((linePB[0] - linePA[0]) * (point[1] - linePA[1]) - (linePB[1] - linePA[1]) * (point[0] - linePA[0])) > 0;
  },

  findDistanceBetweenPointAndLine(point, linePA, linePB) {

    let slope = (linePB[1] - linePA[1]) / (linePB[0] - linePA[0])
    let intercept = linePB[1] - slope * linePB[0]

    let a = 1; let b = -slope; let c = -intercept

    let distance = window.Math.abs(a * point[0] + b * point[1] + c) / window.Math.sqrt(a * a + b * b)
    return distance

  },

  getPolygonBoundary(points) {

    let latMin, latMax, lonMin, lonMax

    for (let i = 0; i < points.length; i += 2) {

      let lon = points[i]
      let lat = points[i + 1]

      if (!latMin || lat < latMin) latMin = lat;
      if (!latMax || lat > latMax) latMax = lat;
      if (!lonMax || lon > lonMax) lonMax = lon;
      if (!lonMin || lon < lonMin) lonMin = lon;

    }

    return [lonMin, latMax, lonMax, latMax, lonMax, latMin, lonMin, latMin, lonMin, latMax]


  },

  getRectangeleCenter(points) {

    let [lonMin, latMax, _, __, lonMax, latMin, ____, ___, ..._____] = points;

    let center = utils.getMidpoint([lonMin, latMax], [lonMax, latMin])

    return center

  },

  getRandomColor() {
    var letters = '0123456789ABCDEF',
      color = '#';

    for (var i = 0; i < 6; i++) color += letters[Math.floor(Math.random() * 16)];

    return color;
  },

  getFormatedDate(ms) {
    //Jan 31 2024

    ms = ms || new Date().getTime()

    let date = new Date(ms)
    let t = date.toString().split(" ");

    return `${t[1]} ${t[2]} ${t[3]}`

  },

  getClickableItem(items) {

    if (!items.length) return

    for (let i = 0; i < items.length; i++) {

      let item = items[i];

      if (item.id.name == 'viewShedRegionWithOutline') continue

      return item

    }



  },

  minToTimeInDays: (minutes) => {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    let date = new Date()
    date.setDate(date.getDate() + (parseInt(minutes / 60 / 24)));
    return `${parseInt(minutes / 60 / 24) ? (date.getDate()) + "-" + months[date.getMonth()] + "-" + date.getFullYear() + " " : ""}${("0" + (parseInt(minutes / 60) - parseInt(minutes / 60 / 24) * 24)).slice(-2)}:${("0" + parseInt(minutes - (parseInt(minutes / 60) * 60))).slice(-2)}`;
  },
  startDateAndMinToTimeInDays: (startDate, minutes) => {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    let date = new Date(startDate)
    date.setDate(date.getDate() + (parseInt(minutes / 60 / 24)));
    return `${parseInt(minutes / 60 / 24) ? (date.getDate()) + "-" + months[date.getMonth()] + "-" + date.getFullYear() + " " : ""}${("0" + (parseInt(minutes / 60) - parseInt(minutes / 60 / 24) * 24)).slice(-2)}:${("0" + parseInt(minutes - (parseInt(minutes / 60) * 60))).slice(-2)}`;
  },
  minToHrs: (minutes) => {
    return `${("0" + parseInt(minutes / 60)).slice(-2)}:${("0" + parseInt(minutes - (parseInt(minutes / 60) * 60))).slice(-2)}`
  },
  minToHrsWithLabel: (minutes) => {
    // console.log(minutes,(minutes / 60) - parseInt(minutes / 60 / 24))
    return (
      (parseInt(minutes / 60 / 24) ? (`${parseInt(minutes / 60 / 24)} ` + (((parseInt(minutes / 60 / 24) > 1) ? '<span style="color:#707174">D</span>' : '<span style="color:#707174">D</span>') + ` `)) : '') +
      (((minutes / 60 % 24) >= 1) ? (parseInt(minutes - (parseInt(minutes / 60) * 60)) ? (`${("0" + parseInt((minutes / 60) - parseInt(minutes / 60 / 24) * 24)).slice(-2)} ` + ((parseInt(minutes / 60 % 24) > 1) ? '<span style="color:#707174">Hr</span>' : '<span style="color:#707174">Hr</span>') + ` : `) : (`${("0" + parseInt((minutes / 60) - parseInt(minutes / 60 / 24) * 24)).slice(-2)} ` + ((parseInt(minutes / 60 % 24) > 1) ? '<span style="color:#707174">Hr</span>' : '<span style="color:#707174">Hr</span>'))) : '') +
      (parseInt(minutes - (parseInt(minutes / 60) * 60)) ? `${("0" + parseInt(minutes - (parseInt(minutes / 60) * 60))).slice(-2)} ` + ((parseInt(minutes - (parseInt(minutes / 60) * 60)) > 1) ? '<span style="color:#707174">min</span>' : '<span style="color:#707174">min</span>') : ''));
  },
  minToHrsWithHrsMinLabel: (minutes) => {
    return ((parseInt(minutes / 60) ? (parseInt(minutes - (parseInt(minutes / 60) * 60)) ? (`${("0" + parseInt(minutes / 60)).slice(-2)} ` + ((parseInt(minutes / 60) > 1) ? '<span style="color:#707174">hours</span>' : '<span style="color:#707174">hour</span>') + ` : `) : (`${("0" + parseInt(minutes / 60)).slice(-2)} ` + ((parseInt(minutes / 60) > 1) ? '<span style="color:#707174">hours</span>' : '<span style="color:#707174">hour</span>'))) : '') + (parseInt(minutes - (parseInt(minutes / 60) * 60)) ? `${("0" + parseInt(minutes - (parseInt(minutes / 60) * 60))).slice(-2)} ` + ((parseInt(minutes - (parseInt(minutes / 60) * 60)) > 1) ? '<span style="color:#707174">minutes</span>' : '<span style="color:#707174">minute</span>') : ''));
  },
  ReverseGeo: async (lat, lng, globalStore) => {

    let details = await globalStore.reverseGeoCode.getPlaceDetails({ location: [lat, lng] })
    let Address = ""

    if (details != undefined) {
      let { name, country, state, city } = details.properties;
      let address = (country || '')

      address += state ? ', ' + state : ''
      Address = name + ',' + city + ',' + state + ',' + country
      return Address;

      //   document.getElementById(`${clickedbtn}latlng-${activetab}`).value = name + ',' + city + ',' + state + ',' + country
    } else {
      //   document.getElementById(`${clickedbtn}latlng-${activetab}`).value = `${lat},${lng}`
      return `${lat} , ${lng}`;

    }
  },
  convertXLDateToJSDate(serial) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;

    var total_seconds = Math.floor(86400 * fractional_day);

    var seconds = total_seconds % 60;

    total_seconds -= seconds;

    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  },
  getISTfromIUTC(time) {
    let ms = new Date(time).getTime()
    return ms + (5.5 * 60 * 60 * 1000)
  },
  getUTCtoIST(time) {
    let ms = new Date(time).getTime()
    return ms - (5.5 * 60 * 60 * 1000)
  },
  getLocalDate: (ms) => {

    let date = new Date(ms)
    let t = date.toString().split(" ");

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    let str = `${strTime} | ${t[2]} ${t[1]} ${t[3]}`

    return str;
  },
  _getLocalDate: (ms) => {

    ms = ms || new Date().getTime()

    let date = String(new Date(parseFloat(ms)).toLocaleDateString('default')).split('/')
    let new_date = [date[2], date[0], date[1]].map(d => d.length == 1 ? '0' + String(d) : d).join('-')
    return new_date
  },
  getNormalDate: (ms) => {

    let date = String(new Date(ms).toLocaleDateString('default')).split('/')
    let new_date = [date[1], date[0], date[2]].map(d => d.length == 1 ? '0' + String(d) : d).join('/')
    return new_date
  },
  split_getLocalDate: (ms) => {

    ms = ms ? ms : new Date().getTime();

    let date_obj = new Date(ms)
    let date_str = JSON.stringify(date_obj).split('"')[1].split('T')[0]

    let hours = date_obj.getHours();
    let minutes = date_obj.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let time_str = hours + ':' + minutes + ' ' + ampm;

    return [time_str, date_str]
  },
  getLocalFullDate_reverse(ms) {
    ms = ms || new Date().getTime()

    const data = new Date(ms)
    const yyyy = data.getFullYear()
    let mm = data.getMonth() + 1
    let dd = data.getDate()

    if (dd < 10) dd = '0' + dd
    if (mm < 10) mm = '0' + mm

    const D = [yyyy, mm, dd].join('-')

    return D
  },
  getLocalFullDate(ms) {

    ms = ms || new Date().getTime()

    let data = new Date(ms)
    const yyyy = data.getFullYear();
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const D = dd + '-' + mm + '-' + yyyy;

    return D;
  },
  NEW_getLocalFullDate(ms) {

    if (!ms) return '-'

    let data = new Date(ms)
    const yyyy = data.getFullYear();
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const D = dd + '/' + mm + '/' + yyyy;

    return D;
  },
  getDurationStr(ms) {
    const millisecondsPerSecond = 1000;
    const millisecondsPerMinute = millisecondsPerSecond * 60;
    const millisecondsPerHour = millisecondsPerMinute * 60;
    const millisecondsPerDay = millisecondsPerHour * 24;
    const millisecondsPerMonth = millisecondsPerDay * 30; // Approximate value

    const months = Math.floor(ms / millisecondsPerMonth);
    ms = ms % millisecondsPerMonth;

    const days = Math.floor(ms / millisecondsPerDay);
    ms = ms % millisecondsPerDay;

    const hours = Math.floor(ms / millisecondsPerHour);
    ms = ms % millisecondsPerHour;

    const minutes = Math.floor(ms / millisecondsPerMinute);
    ms = ms % millisecondsPerMinute;

    const seconds = Math.floor(ms / millisecondsPerSecond);

    let res = ''

    if (months > 0) res += ` ${months}M`
    if (days > 0) res += ` ${days}D`
    if (hours > 0) res += ` ${hours}Hr`
    if (minutes > 0) res += ` ${minutes}Min`
    // if (seconds > 0) res += ` ${seconds}Sec`

    return res;
  },
  getTimeRemaning(time) {

    let D = 0, H = 0, M = 0, Mn = 0;
    let timediff = (new Date(time).getTime() - new Date().getTime())

    timediff = Math.floor(timediff / 1000)

    if (timediff < 3600) //less than an hour
    {

      M = Math.floor(timediff / 60);
    }
    else if (timediff < 86400) //less than a day
    {
      H = Math.floor(timediff / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }
    else if (timediff < 2592000) //less than a month
    {
      D = Math.floor(timediff / 86400);
      H = Math.floor((timediff % 86400) / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }
    else if (timediff < 3.154e+7) //less than a years
    {
      Mn = Math.floor(timediff / 2.628e+6);
      D = Math.floor((timediff % 2.628e+6) / 86400);
      H = Math.floor((timediff % 86400) / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }

    if (timediff < 0)
      return "Expired";
    else if (Mn > 0)
      return `${Mn}M ${D}d ${H}h ${M}m`
    else if (D > 0)
      return `${D}d ${H}h ${M}m`
    else if (H > 0)
      return `${H}h ${M}m`
    else
      return `${M}m`

  },
  getLastupatedStr(time) {

    let D = 0, H = 0, M = 0, Mn = 0;
    let timediff = time

    timediff = Math.floor(timediff / 1000)

    if (timediff < 3600) //less than an hour
    {

      M = Math.floor(timediff / 60);
    }
    else if (timediff < 86400) //less than a day
    {
      H = Math.floor(timediff / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }
    else if (timediff < 2592000) //less than a month
    {
      D = Math.floor(timediff / 86400);
      H = Math.floor((timediff % 86400) / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }
    else if (timediff < 3.154e+7) //less than a years
    {
      Mn = Math.floor(timediff / 2.628e+6);
      D = Math.floor((timediff % 2.628e+6) / 86400);
      H = Math.floor((timediff % 86400) / 3600);
      M = Math.floor((timediff % 3600) / 60);
    }

    if (timediff <= 0)
      return "Live";
    else if (Mn > 0)
      return `${Mn}M ${D}d ${H}h ${M}m`
    else if (D > 0)
      return `${D}d ${H}h ${M}m`
    else if (H > 0)
      return `${H}h ${M}m`
    else
      return `${M}m`

  },
  getDayRemaning(time) {

    const givenDate = new Date(time);
    const currentDate = new Date();
    const timeDiff = givenDate.getTime() - currentDate.getTime();
    const oneYear = 1000 * 60 * 60 * 24 * 365;
    const oneMonth = 1000 * 60 * 60 * 24 * 30;
    const oneDay = 1000 * 60 * 60 * 24;

    if (timeDiff < 0) return "Expired";

    const years = Math.floor(timeDiff / oneYear);
    const months = Math.floor((timeDiff % oneYear) / oneMonth);
    const days = Math.floor(((timeDiff % oneYear) % oneMonth) / oneDay);

    return `${years ? `${years}Y` : ''} ${months ? `${months}M` : ''} ${days ? `${days}D` : ''}`;

  },
  getLocalFullDate_reverse(ms) {

    if (!ms) ms = new Date().getTime()

    let data = new Date(ms)
    let yyyy = data.getFullYear();
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const D = [yyyy, mm, dd].join('-')

    return D;
  },
  _getLocalFullDate(ms) {

    if (!ms) ms = new Date().getTime()

    let data = new Date(ms)
    let yyyy = data.getFullYear();
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;


    let hours = data.getHours();
    let minutes = data.getMinutes();

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    const D = [yyyy, mm, dd].join('-') + "T" + `${hours}:${minutes}`

    return D;
  },
  getDayfromValue(value) {

    let data = new Date()
    let yyyy = data.getFullYear();
    let mm = data.getMonth();
    let dd = data.getDate() + value;

    new Date(yyyy, mm, dd)

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return new Date(yyyy, mm, dd).getTime()
  },
  getEasyDate(duration) {

    let [start, end] = [undefined, undefined]

    // "2022-11-06T10:15"

    if (duration == 'tomorrow') {

      let date_Obj = new Date()
      let yyyy = date_Obj.getFullYear();
      let mm = date_Obj.getMonth() + 1;
      let dd = date_Obj.getDate() + 1;

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      start = ([yyyy, mm, dd].join('-')) + 'T00:00'
      end = ([yyyy, mm, dd].join('-')) + 'T23:59'
    }
    else if (duration == 'today') {

      let date_Obj = new Date()
      let yyyy = date_Obj.getFullYear();
      let mm = date_Obj.getMonth() + 1;
      let dd = date_Obj.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      start = ([yyyy, mm, dd].join('-')) + 'T00:00'
      end = ([yyyy, mm, dd].join('-')) + 'T23:59'
    }
    else if (duration == 'yesterday') {

      let date_Obj = new Date()
      date_Obj.setDate(date_Obj.getDate() - 1);
      let yyyy = date_Obj.getFullYear();
      let mm = date_Obj.getMonth() + 1;
      let dd = date_Obj.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      start = ([yyyy, mm, dd].join('-')) + 'T00:00'
      end = ([yyyy, mm, dd].join('-')) + 'T23:59'
    }
    else if (duration == 'week') {

      let date_Obj = new Date()
      let firstday = new Date(date_Obj.setDate(date_Obj.getDate() - date_Obj.getDay()))
      let lastday = new Date(date_Obj.setDate(date_Obj.getDate() - date_Obj.getDay() + 6))

      {
        let yyyy = firstday.getFullYear();
        let mm = firstday.getMonth() + 1;
        let dd = firstday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        start = ([yyyy, mm, dd].join('-')) + 'T00:00'

      }
      {
        let yyyy = lastday.getFullYear();
        let mm = lastday.getMonth() + 1;
        let dd = lastday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        end = ([yyyy, mm, dd].join('-')) + 'T23:59'

      }
    }
    else if (duration == 'month') {

      let date_Obj = new Date()
      // Set firstday to the 1st of the current month
      let firstday = new Date(date_Obj.getFullYear(), date_Obj.getMonth(), 1)
      let lastday = new Date(date_Obj.getFullYear(), date_Obj.getMonth() + 1, 0)

      {
        let yyyy = firstday.getFullYear();
        let mm = firstday.getMonth() + 1;
        let dd = firstday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        start = ([yyyy, mm, dd].join('-'))

      }
      {
        let yyyy = lastday.getFullYear();
        let mm = lastday.getMonth() + 1;
        let dd = lastday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        end = ([yyyy, mm, dd].join('-'))

      }
    }
    else if (duration == 'year') {

      let date_Obj = new Date()
      let firstday = new Date(date_Obj.getFullYear(), 0, 1)
      let lastday = new Date(date_Obj.getFullYear(), 12, 0)

      {
        let yyyy = firstday.getFullYear();
        let mm = firstday.getMonth() + 1;
        let dd = firstday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        start = ([yyyy, mm, dd].join('-')) + 'T00:00'

      }
      {
        let yyyy = lastday.getFullYear();
        let mm = lastday.getMonth() + 1;
        let dd = lastday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        end = ([yyyy, mm, dd].join('-')) + 'T23:59'

      }
    } 
    else if (duration == 'last_week') {
      let date_Obj = new Date()
      let firstday = new Date(date_Obj.setDate(date_Obj.getDate() - date_Obj.getDay() - 7))
      let lastday = new Date(date_Obj.setDate(date_Obj.getDate() - date_Obj.getDay() + 1))

      {
        let yyyy = firstday.getFullYear();
        let mm = firstday.getMonth() + 1;
        let dd = firstday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        start = ([yyyy, mm, dd].join('-')) + 'T00:00'

      }
      {
        let yyyy = lastday.getFullYear();
        let mm = lastday.getMonth() + 1;
        let dd = lastday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        end = ([yyyy, mm, dd].join('-')) + 'T23:59'

      }
    }
    else if (duration == 'last_month') {
      let date_Obj = new Date()
      let firstday = new Date(date_Obj.getFullYear(), date_Obj.getMonth() - 1, 1)
      let lastday = new Date(date_Obj.getFullYear(), date_Obj.getMonth(), 0)

      {
        let yyyy = firstday.getFullYear();
        let mm = firstday.getMonth() + 1;
        let dd = firstday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        start = ([yyyy, mm, dd].join('-')) + 'T00:00'

      }
      {
        let yyyy = lastday.getFullYear();
        let mm = lastday.getMonth() + 1;
        let dd = lastday.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        end = ([yyyy, mm, dd].join('-')) + 'T23:59'

      }
    }

    return { start, end }
  },
  getCurrentYear() {
    return new Date().getFullYear()
  },
  getWeekStartEndDate(week, month, year) {
    // month is 1 - Jan, 2 -feb...
    //week is 1 - 4

    week = parseInt(week)
    month = parseInt(month)
    year = parseInt(year)

    week = week || new Date().getWeek()
    month = month || new Date().getMonth() + 1
    year = year || new Date().getFullYear()

    // give me start and end in this format start: 2021-01-01T00:00, end: 2021-01-07T23:59

    let first = new Date(year, month - 1, 1);
    let last = new Date(year, month, 0);

    let firstday = first.getDate() - first.getDay();
    let lastday = last.getDate() - last.getDay();

    let start = new Date(year, month - 1, firstday + (week - 1) * 7)
    let end = new Date(year, month - 1, firstday + (week - 1) * 7 + 6)

    let yyyy = start.getFullYear();
    let mm = start.getMonth() + 1;
    let dd = start.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    start = ([yyyy, mm, dd].join('-')) + 'T00:00'

    yyyy = end.getFullYear();
    mm = end.getMonth() + 1;
    dd = end.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    end = ([yyyy, mm, dd].join('-')) + 'T23:59'

    return { start, end }

  },

  getDuration(start, end, format = 'D:H:M') {
    // Calculate the time difference in milliseconds
    const timeDiff = Math.abs(end - start);

    // Calculate days, hours, and minutes
    const days = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
    const hours = Math.floor((timeDiff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((timeDiff % (60 * 60 * 1000)) / (60 * 1000));

    if (format == 'D:H:M') return `${days}D:${hours}H:${minutes}M`;
    else if (format == 'H:M') return `${hours}H:${minutes}M`;
    else if (format == 'days') return days;
    else if (format == 'hours') return hours;
    else if (format == 'minutes') return minutes;

  },
  getDurationStartEnd() {

    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime();
    const yesterdayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
    const yesterdayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59, 999).getTime();
    const weekStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay()).getTime();
    const weekEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (6 - now.getDay()), 23, 59, 59, 999).getTime();
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999).getTime();



    return {
      today: { start: todayStart, end: todayEnd },
      yesterday: { start: yesterdayStart, end: yesterdayEnd },
      week: { start: weekStart, end: weekEnd },
      month: { start: monthStart, end: monthEnd }
    };

  },
  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  synchronousLoop(data, processData, done) {

    let isBreaked = false

    let breakloop = () => {
      isBreaked = true
      console.log('isBreaked', isBreaked);
      return isBreaked;
    }

    if (data.length > 0) {

      let loop = (data, i, processData, done) => {

        if (isBreaked) return done();

        processData(data[i], i, () => {

          if (++i < data.length) setTimeout(() => loop(data, i, processData, done), 0)
          else done();
        })

      }

      loop(data, 0, processData, done)

    } else done()

    return breakloop;

  },
  getCustomFullDate(formate, type) {

    let date = new Date(),
      current_year = date.getFullYear(),
      current_day = date.getDate(),
      current_month = date.getMonth();

    let stack = []

    if (formate == 'day') {

      for (let i = 0; i < current_day; i++) {

        let start = new Date(current_year, current_month, i)
        let end = new Date(current_year, current_month, i)

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        if (type == 'office-ride') {
          stack.push({ index: i, start, end })
        }
        else {
          stack.push({ index: i, start: JSON.stringify(start), end: JSON.stringify(end) })
        }
      }
    }
    else if (formate == 'month') {


      for (let i = 0; i <= current_month; i++) {

        let start = new Date(current_year, i, 1)
        let end = new Date(current_year, i, 31)

        end = i == current_month ? new Date() : end;

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        if (type == 'office-ride') {
          stack.push({ index: i, start, end })
        }
        else {
          stack.push({ index: i, start: JSON.stringify(start), end: JSON.stringify(end) })
        }
      }
    }
    else if (formate == 'week') {

      const weeks = [],
        firstDate = new Date(current_year, current_month, 1),
        lastDate = new Date(current_year, current_month + 1, 0),
        numDays = lastDate.getDate();

      let dayOfWeekCounter = firstDate.getDay();

      for (let date = 1; date <= numDays; date++) {

        if (date > current_day) break;

        if (dayOfWeekCounter === 0 || weeks.length === 0) {
          weeks.push([]);
        }
        weeks[weeks.length - 1].push(date);
        dayOfWeekCounter = (dayOfWeekCounter + 1) % 7;
      }

      weeks
        .filter((w) => !!w.length)
        .map((w, i) => {


          let start = new Date(current_year, current_month, (w[0] - 1))
          let end = new Date(current_year, current_month, (w[w.length - 1] - 1))

          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 999);

          if (type == 'office-ride') {
            stack.push({ index: i, start, end })
          }
          else {
            stack.push({ index: i, start: JSON.stringify(start), end: JSON.stringify(end) })
          }
        });
    }

    return stack
  },
  getCurrent_Day(type) {

    JSON.stringify
    let start = new Date();
    start.setHours(0, 0, 0, 0);
    let end = new Date();
    end.setHours(23, 59, 59, 999);

    if (type == 'office-ride') {
      return { start: start, end: end }
    }
    else {
      return { start: JSON.stringify(start), end: JSON.stringify(end) }
    }
  },
  getCurrent_Week(type) {

    let curr = new Date();
    let first = curr.getDate() - curr.getDay();
    let last = first + 6;
    let start = new Date(curr.setDate(first))
    let end = new Date(curr.setDate(last))

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    if (type == 'office-ride') {
      return { start: start, end: end }
    }
    else {
      return { start: JSON.stringify(start), end: JSON.stringify(end) }
    }
  },
  getCurrent_Month(type) {

    let date = new Date(), y = date.getFullYear(), m = date.getMonth();
    let start = new Date(y, m, 1)
    let end = new Date(y, m + 1, 0)

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);


    if (type == 'office-ride') {
      return { start: start, end: end }
    }
    else {
      return { start: JSON.stringify(start), end: JSON.stringify(end) }
    }
  },
  getCurrent_year(type) {

    let currentYear = new Date().getFullYear();
    let start = new Date(currentYear, 0, 1);
    let end = new Date(currentYear, 11, 31);

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);


    if (type == 'office-ride') {
      return { start: start, end: end }
    }
    else {
      return { start: JSON.stringify(start), end: JSON.stringify(end) }
    }
  },

  getTableCols(table) {

    var th = table.querySelectorAll('thead tr:first-child th');

    return [].reduce.call(th, function (p, c) {
      var colspan = c.getAttribute('colspan') || 1;
      return p + +colspan;
    }, 0);
  },

  BasicReverseGeo: async (lat, lng, globalStore) => {

    let details = null;
    try {
      details = await globalStore.reverseGeoCode.getPlaceDetails({ location: [lat, lng] })
    } catch {
      details = undefined;
    }
    let Address = ""

    if (details != undefined) {
      let { name, country, state, city, postcode } = details.properties;
      let address = (country || '')
      let tempName = (name != undefined) ? `${name}, ` : ``
      let tempCity = (city != undefined) ? `${city}, ` : ``
      let tempCountry = (country != undefined) ? `${country}, ` : ``
      let tempState = (state != undefined) ? `${state}, ` : ``

      address += state ? ', ' + state : ''
      Address = tempName + tempCity + tempState + tempCountry + postcode
      return Address;

      //   document.getElementById(`${clickedbtn}latlng-${activetab}`).value = name + ',' + city + ',' + state + ',' + country
    } else {
      //   document.getElementById(`${clickedbtn}latlng-${activetab}`).value = `${lat},${lng}`
      return `${lat} , ${lng}`;

    }
  },
  paginator: (instance, params) => {

    // console.log(instance)
    // console.log(params)
    if (instance.current === undefined) {
      let param = new URLSearchParams(window.location.search);
      instance.current = param.has("pg") ? Number.parseInt(param.get("pg")) : 1;
    }
    if (instance.adj === undefined) { instance.adj = 2; }
    if (instance.adj <= 0) { instance.adj = 1; }
    if (instance.current <= 0) { instance.current = 1; }
    if (instance.current > instance.total) { instance.current = instance.total; }

    // (B) URL STRING ONLY - DEAL WITH QUERY STRING & APPEND PG=N
    const jsmode = typeof instance.click == "function";
    if (jsmode == false) {
      if (instance.click.indexOf("?") == -1) { instance.click += "?pg="; }
      else { instance.click += "&pg="; }
    }

    // (C) HTML PAGINATION WRAPPER
    instance.target.innerHTML = "Pages: &nbsp;";
    instance.target.classList.add("paginate");

    // (D) DRAW PAGINATION SQUARES
    // (D1) HELPER FUNCTION TO DRAW PAGINATION SQUARE
    const square = (txt, pg, css) => {
      let el = document.createElement("a");
      el.innerHTML = txt;
      if (css) { el.className = css; }
      if (jsmode) { el.onclick = () => { instance.click(pg, params); }; }
      else { el.href = instance.click + pg; }
      instance.target.appendChild(el);
      if (pg == 0) {
        instance.target.innerHTML = "";
      }
    };
    // (D2) BACK TO FIRST PAGE (DRAW ONLY IF SUFFICIENT SQUARES)
    if (instance.current - instance.adj > 1) { square("&#10218;", 1, "first"); }

    // (D3) ADJACENT SQUARES BEFORE CURRENT PAGE
    let temp;
    if (instance.current > 1) {
      temp = instance.current - instance.adj;
      if (temp <= 0) { temp = 1; }
      for (let i = temp; i < instance.current; i++) { square(i, i); }
    }

    // (D4) CURRENT PAGE
    square(instance.current, instance.current, "current");

    // (D5) ADJACENT SQUARES AFTER CURRENT PAGE
    if (instance.current < instance.total) {
      temp = instance.current + instance.adj;
      if (temp > instance.total) { temp = instance.total; }
      for (let i = instance.current + 1; i <= temp; i++) { square(i, i); }
    }

    // (D6) SKIP TO LAST PAGE (DRAW ONLY IF SUFFICIENT SQUARES)
    if (instance.current <= instance.total - instance.adj - 1) {
      square("&#10219;", instance.total, "last");
    }
  },
  generateNonRepetitiveNumbers: (min, max) => {
    const numbers = [];

    // Create an array of numbers within the specified range
    for (let i = min; i <= max; i++) {
      numbers.push(i);
    }

    // Shuffle the array using the Fisher-Yates algorithm
    for (let i = numbers.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
    }

    return numbers;
  }
  , toTitleCase: (str) => {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  },
  downloadFile: (url, filename) => {
    try {
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          // console.error('Error downloading file:', error);
          window.open(url, '_blank');
        });
    } catch (e) {
      window.open(url, '_blank');
    }
  },
  addStyleToSvg: (svgString, style = undefined) => {
    if (style == undefined) {
      return svgString
    } else {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgString, 'image/svg+xml');

      const svgElement = svgDoc.documentElement;

      // Add or modify the style attribute
      svgElement.setAttribute('style', style);

      // Convert the modified SVG back to a string
      const modifiedSvgString = new XMLSerializer().serializeToString(svgElement);

      return modifiedSvgString;
    }
  },
  localDate: (date) => {
    if (!date) {
      return '';
    }
    // console.log(new Date(date).toLocaleDateString(), new Date(date).toLocaleDateString("en-IN", {
    //     year: "numeric", month: "2-digit", day: "2-digit",
    // }).split('/').reverse().join('-'))
    // return new Date(date).toLocaleDateString()
    return new Date(date).toLocaleString(undefined, {
      year: "numeric", month: "2-digit", day: "2-digit",
    }).split('/').reverse().join('-')
  },
  LocalDate: (date) => {
    return new Date(date).toLocaleDateString(undefined, {
      year: "numeric", month: "2-digit", day: "2-digit",
    }).split('/').join('-');
  },
  localDateTime: (date) => {
    return new Date(date).toLocaleString(undefined, {
      year: "numeric", month: "2-digit", day: "2-digit", hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).replace(", ", " ")
  },
  utcMillisecond: (value) => {
    const dateValue = new Date(value);
    const utcTimestamp = Date.UTC(
      dateValue.getUTCFullYear(),
      dateValue.getUTCMonth(),
      dateValue.getUTCDate(),
      dateValue.getUTCHours(),
      dateValue.getUTCMinutes(),
      dateValue.getUTCSeconds(),
      dateValue.getUTCMilliseconds()
    );
    return utcTimestamp
  },
  utcAddDaysMillisecond: (value, daysToAdd) => {
    console.log(value, "value", daysToAdd, "daysToAdd");
    const dateValue = new Date(value);
    if (isNaN(dateValue.getTime())) {
      console.warn("Invalid date value:", value);
      return null;
    }
    console.log(dateValue, "dateValue");
    dateValue.setUTCDate(dateValue.getUTCDate() + daysToAdd);

    const utcTimestamp = Date.UTC(
      dateValue.getUTCFullYear(),
      dateValue.getUTCMonth(),
      dateValue.getUTCDate(),
      dateValue.getUTCHours(),
      dateValue.getUTCMinutes(),
      dateValue.getUTCSeconds(),
      dateValue.getUTCMilliseconds()
    );

    return utcTimestamp;
  },

  exportEntireTableAsExcel(tableValues, fileName) {

    const worksheet = XLSX.utils.aoa_to_sheet(tableValues);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(excelData);
    link.download = fileName || "table.xlsx";
    link.click();
  },

  exportTableAsExcel(tableId, fileName, excludedColumns = []) {
    const table = document.getElementById(tableId);
    const tableData = [];

    for (let i = 0; i < table.rows.length; i++) {
      const rowData = [];
      const cells = table.rows[i].cells;

      for (let j = 0; j < cells.length; j++) {
        if (!excludedColumns.includes(j)) {

          const cellElement = cells[j];

          const cellStyle = window.getComputedStyle(cellElement);

          if (cellStyle.display !== "none") {
            let cellValue;
            const selectElement = cellElement.querySelector("select");
            if (selectElement) {
              const selectedOption = selectElement.options[selectElement.selectedIndex];
              cellValue = selectedOption.innerText;
            } else {
              cellValue = cellElement.innerText;
            }

            if (!cellValue.includes('Action')) rowData.push(cellValue);
            else rowData.push('')
          }
        }
      }

      tableData.push(rowData);
    }

    const worksheet = XLSX.utils.aoa_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(excelData);
    link.download = fileName || "table.xlsx";
    link.click();
  },

  downloadTableAsCSV(tableId, fileName, excludedColumns = []) {
    const table = document.getElementById(tableId);
    let csvContent = "";

    for (let i = 0; i < table.rows.length; i++) {
      const cells = table.rows[i].cells;
      for (let j = 0; j < cells.length; j++) {
        if (!excludedColumns.includes(j)) {
          const cellElement = cells[j];
          const cellStyle = window.getComputedStyle(cellElement);

          if (cellStyle.display !== "none") {
            let cellContent;
            const selectElement = cellElement.querySelector("select");
            if (selectElement) {
              cellContent = selectElement.options[selectElement.selectedIndex].innerText;
            } else {
              cellContent = cellElement.innerText;
            }

            if (cellContent.includes('Action')) cellContent = ''

            csvContent += cellContent + ",";
          }
        }
      }
      csvContent += "\n";
    }

    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName || "table.csv";
    link.click();
  },

  formatLocalizedDate(timestamp) {
    if (!timestamp) {
      return "-";
    }

    let date;
    const parsedTimestamp = Number(timestamp);
    if (!isNaN(parsedTimestamp)) {
      date = new Date(parsedTimestamp);
    } else {
      const timestampFromISOString = Date.parse(timestamp);
      if (!isNaN(timestampFromISOString)) {
        date = new Date(timestampFromISOString);
      }
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "-";
    }

    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };

    const formattedDate = date
      .toLocaleString("en-IN", options)
      .replace(/-/g, " ");
    return formattedDate;
  }, arraysAreEqual: (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (var i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }, getNonSimilarPairs: (obj1, obj2) => {
    var nonSimilarPairs = {}; // Object to store non-similar key-value pairs from obj2

    for (var key in obj2) {
      if (obj2.hasOwnProperty(key)) {
        var value1 = obj1[key];
        var value2 = obj2[key];

        if (Array.isArray(value2) && Array.isArray(value1)) {
          // Compare the values of array properties
          var arraysEqual = utils.arraysAreEqual(value1, value2);
          if (!arraysEqual) {
            nonSimilarPairs[key] = value2;
          }
        } else if (value1 !== value2) {
          // Compare non-array values
          nonSimilarPairs[key] = value2;
        }
      }
    }

    return nonSimilarPairs;
  }, validateIMEI: (imei) => {
    // Remove any non-numeric characters from the IMEI
    imei = imei.replace(/\D/g, '');

    // Check if the IMEI is either 15, 16, or 17 digits long
    if (imei.length !== 15 && imei.length !== 16 && imei.length !== 17) {
      return false;
    }

    // Calculate the Luhn checksum
    let sum = 0;
    for (let i = 0; i < imei.length; i++) {
      let digit = parseInt(imei.charAt(i), 10);
      if ((imei.length - i) % 2 === 0) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
    }

    return sum % 10 === 0;
  }, dataBubbleApprox: (value) => {
    if (value >= 10000000) {
      return (value == 10000000) ? '1Cr' : '1Cr+';
    } else if (value >= 100000) {
      return (value % 1000000 === 0) ? (value / 100000) + 'L' : (value / 100000).toFixed(0) + 'L+';
    } else if (value >= 1000000) {
      return (value % 100000 === 0) ? (value / 100000) + 'L' : (value / 100000).toFixed(0) + 'L+';
    } else if (value >= 10000) {
      return (value % 10000 === 0) ? (value / 1000) + 'K' : (value / 1000).toFixed(0) + 'K+';
    } else if (value >= 1000) {
      return (value % 1000 === 0) ? (value / 1000) + 'K' : (value / 1000).toFixed(1) + 'K+';
    } else {
      return value.toString();
    }
    // else if (value >= 10000000) {
    //     return (value % 10000000 === 0) ? (value / 10000000) + 'Cr' : (value / 10000000).toFixed(0) + 'Cr+';
    // } 
  }, getAgeFromDOB(dob) {
    if (!dob) {
      return "-";
    }
    const birthDate = new Date(dob);

    // Check if the date object is valid
    if (isNaN(birthDate.getTime())) {
      return "-";
    }

    const today = new Date();

    const ageInMilliseconds = today - birthDate;
    const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // accounting for leap years
    const ageInYears = Math.floor(ageInMilliseconds / millisecondsPerYear);

    return ageInYears;
  }, setColorProperty(colorCode, backgroundColor, borderColor) {
    document.documentElement.style.setProperty(
      `--management-backGroundColor`,
      backgroundColor
    );
    document.documentElement.style.setProperty(`--management-color`, colorCode);
    document.documentElement.style.setProperty(
      `--management-borderColor`,
      borderColor
    );
    document.documentElement.style.setProperty(
      `--management-urlColor`,
      encodeURIComponent(colorCode)
    );
  }, formatTime(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours > 12 ? " PM" : " AM"}`;
  }, formatDate(date, typeOfMonth) {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: typeOfMonth });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }, formatLicensePlate(inputString) {
    // Use regex to insert spaces before and after capital letter sequences
    const formattedString = inputString.replace(/([A-Z]+)/g, ' $1 ').trim();
    return formattedString;
  }, format12HourTime(hours, minutes) {
    const meridiem = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for midnight
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes} ${meridiem}`;
  }, validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }, validateSearch(search) {
    const searchInput = search.target;
    const key = search.key.toLowerCase();
    const isAlphabetical = /[a-zA-Z0-9 ]/.test(key);
    if (!isAlphabetical) {
      return true;
    }
    if (key === ' ' && searchInput.value.endsWith(' ')) {
      return true;
    }
  },
  validation: (value, type) => {
    if (type === "email") {
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // ^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$
      // return emailRegex.test(value);
      const emailRegex = /^(?!\.)(?!.*?\.\.)(?!.*?\.$)[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,4}$/;
      console.log(emailRegex.test(value), value);
      if (emailRegex.test(value)) return true
      else return { status: false, message: "Enter Valid Email Address" }
    } else if (type === "phone") {
      // const phoneRegex = /^\d{10}$/;
      if (value.length < 10 || value.length > 10) return { status: false, message: "Invalid Phone Number Length" }
      const mobileNumberPattern = /^[6-9]\d{9}$/;
      if (mobileNumberPattern.test(value)) return true
      else return { status: false, message: "Invalid Number Range" }
    } else if (type === "password") {
      if (value.length < 8) return { status: false, message: "Password should be minimum 8 characters" }
      else if (value.length > 16) return { status: false, message: "Password should be maximum 16 characters" }
      else if (value.match(/[a-z]/g) && value.match(/[A-Z]/g) && value.match(/[0-9]/g) && value.match(/[^a-zA-Z\d]/g)) return true
      else return { status: false, message: "Password should contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character" }
    } else if (type === "name") {
      // return value.length > 0;
      if (value.length > 0 && value.length < 80) return true
      else if (value.length > 80) return { status: false, message: "Maximum 80 characters" }
    } else if (type === "number") {
      return value.length > 0;
    } else if (type === "text") {
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const htmlTagsRegex = /<[^>]*>/g;
      if (scriptRegex.test(value) && !htmlTagsRegex.test(value)) return { status: false, message: "Invalid Input" }
      if (value.length > 0 && value.length < 256) return true
      else if (value.length > 256) return { status: false, message: "Maximum 256 characters" }
      else return { status: false, message: "Invalid Input" }
    } else if (type === "gst") {
      const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}$/;
      if (value.length !== 15) return { status: false, message: "Invalid GST Number Length" };
      if (gstRegex.test(value)) return true
      else return { status: false, message: "Invalid GST Number Format" }
    } else if (type === "pan") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      if (value.length !== 10) return { status: false, message: "Invalid PAN Number Length" };
      if (panRegex.test(value)) return true
      else return { status: false, message: "Invalid PAN Number Format" }
    } else if (type === "aadhar") {
      const aadharRegex = /^\d{12}$/;
      if (value.length < 12 || value.length > 12) return { status: false, message: "Invalid Aadhar Number Length" };
      if (aadharRegex.test(value)) return true;
      else return { status: false, message: "Invalid Aadhar Number Format" };
    } else if (type === "pincode") {
      const pincodeRegex = /^\d{6}$/;
      if (value.length < 6 || value.length > 6) return { status: false, message: "Invalid Pincode Length" }
      if (pincodeRegex.test(value)) return true
      else return { status: false, message: "Invalid Pincode Format" }
    } else if (type == "address") {
      // return value.length > 0 && value.length <= 256;
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const htmlTagsRegex = /<[^>]*>/g;
      if (scriptRegex.test(value) && !htmlTagsRegex.test(value)) return { status: false, message: "Invalid Input" }
      if (value.length > 0 && value.length <= 256) return true
      else if (value.length > 256) return { status: false, message: "Maximum 256 characters" }
      else return { status: false, message: "Invalid Input" }
    } else if (type === "cord") {
      const cordRegex = /^-?([1-8]?\d(?:\.\d{1,13})?|90(?:\.0{1,13})?)\s*,\s*-?((?:1[0-7]|[1-9])?\d(?:\.\d{1,13})?|180(?:\.0{1,13})?)$/;
      if (cordRegex.test(value)) {
        // console.log("Valid Coordinates");
        return true;
      } else {
        // console.log("Invalid Coordinates Format");
        return { status: false, message: "Invalid Coordinates Format" }
      }
    } else if (type === "text80") {
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const htmlTagsRegex = /<[^>]*>/g;
      if (scriptRegex.test(value) && !htmlTagsRegex.test(value)) return { status: false, message: "Invalid Entry" }
      if (value.length > 0 && value.length < 80) return true
      else if (value.length > 80) return { status: false, message: "Maximum 80 characters" }
      else return { status: false, message: "Invalid Entry" }
    } else if (type === "text100") {
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const htmlTagsRegex = /<[^>]*>/g;
      if (scriptRegex.test(value) && !htmlTagsRegex.test(value)) return { status: false, message: "Invalid Entry" }
      if (value.length > 0 && value.length < 100) return true
      else if (value.length > 100) return { status: false, message: "Maximum 100 characters" }
      else return { status: false, message: "Invalid Entry" }
    } else if (type.includes("text")) {
      let length = type.split("text")[1];
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      const htmlTagsRegex = /<[^>]*>/g;
      if (scriptRegex.test(value) && !htmlTagsRegex.test(value)) return { status: false, message: "Invalid Entry" }
      if (value.length > 0 && value.length < length) return true
      else if (value.length > length) return { status: false, message: `Maximum ${length} characters` }
      else return { status: false, message: "Invalid Entry" }
    } else if (type === "date") {
      const currentDate = new Date().toISOString().slice(0, 10);
      if (value.match(/^\d{4}-\d{2}-\d{2}$/)) {
        if (value <= currentDate) return true;
        else return { status: false, message: "Invalid Date, Date is greater than current date" };
      }
      return { status: false, message: "Invalid Date Format" };
    } else if (type == "vehicle") {
      const modifiedNumberPlateRegex = /^[A-Z]{2}\s[0-9]{2}\s[A-Z]{1,2}\s[0-9]{4}$/;
      const bhSeriesNumberPlateRegex = /^[0-9]{2}\sBH\s[0-9]{4}\s[A-HJ-NP-Z]{1,2}$/;

      // Adjusting regex to include space after state code for TN series
      const tnSeriesNumberPlateRegex = /^[A-Z]{2}\s\s[0-9]{2}\s[A-Z]{1,2}\s[0-9]{4}$/;

      const regex = /^[A-Z]{2}\s\d{2}\s[A-Z]{1,2}\s\d{4}$/;
      // if (modifiedNumberPlateRegex.test(value) || bhSeriesNumberPlateRegex.test(value) || tnSeriesNumberPlateRegex.test(value)) return true;
      if (regex.test(value)) return true;
      else {
        console.log("Invalid Vehicle Number", value)
        return { status: false, message: "Invalid Vehicle Number" };
      }
    } else {
      return false;
    }

  },
  validateInput: async (element, errorElement, type) => {
    element.addEventListener('input', async () => {
      await utils.validateField(element, errorElement, type);
    });
  },
  validateField: async (element, errorElement, type) => {
    const value = element.value;
    const valid = await utils.validation(value, type);

    if (valid === true) {
      element.classList.remove('invalid');
      errorElement.textContent = '';
      return true;
    } else {
      console.log(element, "element");
      element.classList.add('invalid');
      errorElement.textContent = valid.message;
      return false;
    }
  },
  validateSelect: async (element, errorElement) => {
    element.addEventListener('change', async () => {
      await utils.validateSelectField(element, errorElement);
    });
  },
  validateSelectField: async (element, errorElement) => {
    console.log(element, "element select");
    // check if value is not in the list of options and not in the list of disabled options sometimes values includes empty string
    if (element.options[element.selectedIndex].value === element.value && !element.options[element.selectedIndex].disabled && element.options[element.selectedIndex].style.display !== "none") {
      element.classList.remove('invalid');
      errorElement.textContent = '';
      return true;
    }
    element.classList.add('invalid');
    errorElement.textContent = 'Please select an option';
    return false;
  },
  odoMeterReading(start, end) {
    if (end < start) {
      return "check the EndOdoMeter"
    }
  },
  debounce: (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  },
  applyPermissionControls(globalStore,moduleName) {
		this.globalStore = globalStore;
		// Get the actual permission data from role_access
		const permissionData = this.globalStore.roleAccess.role.role_access?.find(module => 
			module.feature_key === moduleName
		)
		
		if (!permissionData) {
			return
		}
		
		
		// Create permission
		const canCreate = !(permissionData._create === 0 || permissionData._create === false)
		const createSelectors = ['.add-newrec', '.add-btn', '.create-btn', '[data-action="create"]', '[data-action="add"]']
		
		if (!canCreate) {
			this.hideElementsBySelector(createSelectors)
		} else {
			this.showElementsBySelector(createSelectors)
		}
		
		// Edit permission
		const canEdit = !(permissionData._edit === 0 || permissionData._edit === false)
		const editSelectors = ['.edit', '.figure', '.edit-btn', '.edit-button', '.table-editIcon', '[data-action="edit"]', '.fa-edit', '.fa-pencil', '.edit-icon']
		
		if (!canEdit) {
			this.hideElementsBySelector(editSelectors)
		} else {
			this.showElementsBySelector(editSelectors)
		}
		
		// Delete permission
		const canDelete = !(permissionData._delete === 0 || permissionData._delete === false)
		const deleteSelectors = ['.delete', '.delete-image', '.figure', '.delete-btn', '.delete-button', '.table-cancelIcon', '[data-action="delete"]', '.fa-trash', '.fa-times', '.delete-icon']
		
		if (!canDelete) {
			this.hideElementsBySelector(deleteSelectors)
		} else {
			this.showElementsBySelector(deleteSelectors)
		}
		
		// Detailed view permission (for view icons in list pages)
		const canDetailedView = !(permissionData._detailed_view === 0 || permissionData._detailed_view === false)
		const viewSelectors = ['.view', '.view-icon', '.view-btn', '.view-button', '.table-viewIcon', '[data-action="view"]', '.fa-eye', '.eye-icon']
		
		if (!canDetailedView) {
			this.hideElementsBySelector(viewSelectors)
		} else {
			this.showElementsBySelector(viewSelectors)
		}
		
		// Card view permission
		const canViewCards = !(permissionData._card_view === 0 || permissionData._card_view === false)
		const cardSelectors = ['.card', 'card-res-adjust', '.card-view-toggle', '.view-toggle', '[data-view="card"]']
		
		if (!canViewCards) {
			this.hideElementsBySelector(cardSelectors)
		} else {
			this.showElementsBySelector(cardSelectors)
		}
		
		// Bulk actions are controlled by delete permission
		const bulkSelectors = ['.bulk-actions', '.bulk-delete', '[data-action="bulk"]']
		
		if (!canDelete) {
			this.hideElementsBySelector(bulkSelectors)
		} else {
			this.showElementsBySelector(bulkSelectors)
		}
		
	},
	hideElementsBySelector(selectors) {
		
		let totalHidden = 0
		selectors.forEach(selector => {
			const elements = document.querySelectorAll(selector)
			
			elements.forEach((element, index) => {
				if (element) {
					element.style.display = 'none'
					totalHidden++
				}
			})
		})
		
	},
	
	showElementsBySelector(selectors) {
		let totalShown = 0
		
		selectors.forEach(selector => {
			const elements = document.querySelectorAll(selector)
			elements.forEach((element, index) => {
				if (element) {
					// Remove display:none to make it visible
					if (element.style.display === 'none') {
						element.style.display = ''
						totalShown++
					}
				}
			})
		})
		
	}

}

module.exports = utils